﻿import { ajaxGet, ajaxPost } from '../../utils/ajax';

export default {    
    setCreditCheckNewCreditLimit(orderId,  amount, vat, currency, callback, errorCallback) {
        var url = "/teliadk/CreditEvaluationCreditAccountBlock/SetCreditCheckNewCreditLimit?orderId=" + orderId;
        ajaxPost(url, createMoneyParameter(amount, vat, currency))
            .then(callback)
            .catch(errorCallback);
    },
    setCreditCheckOptions(orderId, params){
        var url = "/teliadk/CreditEvaluationCreditAccountBlock/SetCreditCheckOptions?orderId=" + orderId;
        ajaxPost(url, createCrecitCheckOptionsParams(params));
    },
    setCreditCheckResult(orderId, creditTermsString, param, callback,  errorCallback) {  
        var url = "/teliadk/CreditEvaluationCreditAccountBlock/SetCreditCheckResultAsync?orderId=" + orderId + "&creditTermsString=" + creditTermsString;
        ajaxPost(url, param)
            .then(callback)
            .catch(errorCallback);
    },
    externalCreditCheck(orderId, parameters, callback, errorCallback){       
        var url = "/teliadk/CreditEvaluationCreditAccountBlock/ExternalCreditCheckAsync?orderId=" + orderId;
        ajaxPost(url, parameters)
        .then(callback)
        .catch(errorCallback);
    }
}

function createCrecitCheckOptionsParams(params){
    if(params.currentCreditLimitAmount){
        return {
            'availableAmount.amount': params.availableAmount,
            'availableAmount.vat': params.availableAmountVat,
            'availableAmount.currency': params.availableAmountCurrency,
            'currentCreditLimit.amount': params.currentCreditLimitAmount,
            'currentCreditLimit.vat': params.currentCreditLimitVat,
            'currentCreditLimit.currency': params.currentCreditLimitCurrency,
            'creditStepsAvailable': params.creditSteps,
            'lastRetrievalStatus': params.lastRetrievalStatus
        };
    }        
    else{
        return {
            'creditStepsAvailable': params.creditSteps,
            'lastRetrievalStatus': params.lastRetrievalStatus
        };
    }
}


function createMoneyParameter(amount, vat, currency){
    return {
        "currency": currency,
        "amount": Number(amount.toFixed(2)), //credit limit amounts has to be stored as 2 decimal values
        "vat": vat
    };
}